<template>
  <ProprietaireCreateCompte />
</template>

<script>
  import ProprietaireCreateCompte from "@/components/ProprietaireCreateCompte.vue";
  export default {
    name: "ProductListPage",
    components: {
      ProprietaireCreateCompte,
    },
    data() {
      return {};
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
